'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/minutesUntil.js
// module id = 264
// module chunks = 1